module.exports = __webpack_public_path__ + "static/media/线稿上色.c9a1950a.png";